import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '所属行业'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }
]
